<template>
  <div
    class="mac-folder-icon flex flex-col items-center cursor-pointer select-none group transition-transform duration-200 group-hover:-translate-y-0.5"
    @click="handleClick"
    @dblclick="handleDblClick"
  >
    <img
      :src="iconSrc"
      :alt="label"
      class="w-16 h-14 object-contain transition-transform duration-200 group-hover:scale-[1.03]"
    >
    <!-- Label box (white with black border) -->
    <div
      class="mac-folder-icon-label mt-1 px-2 py-0.5 border border-black bg-white text-center min-w-[60px] group-hover:bg-gray-100 transition-colors"
      :class="singleLine ? 'max-w-none whitespace-nowrap' : 'max-w-[90px]'"
    >
      <span
        class="font-pixel text-xl font-medium text-black"
        :class="singleLine ? '' : 'break-words'"
      >{{ label }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import folderIcon from '@/assets/folder-icon.png'

const props = defineProps({
  label: { type: String, required: true },
  icon: { type: String, default: null },
  openOnSingleClick: { type: Boolean, default: false },
  /** Keep label on one line (wider box, no word break). */
  singleLine: { type: Boolean, default: false },
})

const emit = defineEmits(['open'])

const iconSrc = computed(() => props.icon || folderIcon)

/** Open with one tap when device is touch-like or viewport is narrow (dblclick is unreliable on touch). */
const useSingleTapOpen = ref(false)

let mqCoarse = null
let mqSmall = null

function updateSingleTapMode() {
  useSingleTapOpen.value =
    props.openOnSingleClick ||
    mqCoarse?.matches ||
    mqSmall?.matches
}

onMounted(() => {
  mqCoarse = window.matchMedia('(pointer: coarse)')
  mqSmall = window.matchMedia('(max-width: 900px)')
  updateSingleTapMode()
  mqCoarse.addEventListener('change', updateSingleTapMode)
  mqSmall.addEventListener('change', updateSingleTapMode)
})

onUnmounted(() => {
  mqCoarse?.removeEventListener('change', updateSingleTapMode)
  mqSmall?.removeEventListener('change', updateSingleTapMode)
})

function handleClick() {
  if (useSingleTapOpen.value) emit('open')
}

function handleDblClick() {
  if (!useSingleTapOpen.value) emit('open')
}
</script>
